import type { PathLookupGraphPreset } from '@ipfabric/utils';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import { setAppliedPreset } from 'components/Graph/commands/settings/setAppliedPreset';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';

export const applyPathLookupSettings: GraphCommandFactory = (
  cmdContext,
  dispatch,
) => {
  const makeApplyPreset = (preset: PathLookupGraphPreset) => async () => {
    dispatch(setAppliedPreset, { preset });
    cmdContext.updateState((draft) => {
      draft.pathlookup.presetDraft = preset;
      draft.pathlookup.preset = preset;
    });
    const state = cmdContext.getState();
    if (selectPathLookupApplied(state) && state.loading !== 'ERROR') {
      await dispatch(loadGraph, {
        overlay: 'keep',
        preserveHistory: true,
      });
    }
  };
  return async () => {
    await dispatch(performUndoableAction, {
      undo: makeApplyPreset(cmdContext.getState().pathlookup.preset),
      redo: makeApplyPreset(cmdContext.getState().pathlookup.presetDraft),
    });
  };
};
